module.exports = __webpack_public_path__ + "img/gg.a4952881.svg";